/* eslint-disable react/prop-types */
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS104: Avoid inline assignments
 * DS201: Simplify complex destructure assignments
 * DS204: Change includes calls to have a more natural evaluation order
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import classNames from 'classnames';
import reactUpdate from 'immutability-helper';
import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';
import _ from 'underscore';

import * as analytics from 'analytics/Analytics';
import BufferOptions from 'buffers/BufferOptions';
import BufferOptionsItem from 'buffers/BufferOptionsItem';
import FormattersConstants from 'notebook/mediocre/formatted-text/FormattersConstants';
import * as MaterialConstants from 'notebook/protocols/MaterialConstants';
import throttle from 'util/throttle';

const {LEVEL_MATERIAL} = MaterialConstants;

import * as StepConstants from 'notebook/protocols/StepConstants';

import PropTypes from 'prop-types';

import {isBrowser} from 'lib/Browser';
import DocumentManagerComponentClass from 'notebook/mediocre/core-ui/DocumentManagerComponent';
import * as TableConstants from 'notebook/tables/TableConstants';
import * as excessutil from 'notebook/tables/excess/Util';

const {TABLE_NAME_WELL_PREFIX, DEFAULT_TABLE_SIZE, DEFAULT_PLATE_SIZE} = TableConstants;

import DisplayOptions from 'settings/visibility-options/DisplayOptions';
import getEditorMargin from 'notebook/mediocre/core-ui/getEditorMargin';
import FormatState from 'notebook/mediocre/formatted-text/FormatState';
import {
  EditLinkModal,
  formatText,
  getEditingLinkState,
} from 'notebook/mediocre/formatted-text/FormatTextUtil';
import formatters from 'notebook/mediocre/formatted-text/formatters';
import PositionedLinkPopover from 'notebook/mediocre/hyperlinks/PositionedLinkPopover';
import SelectionReader from 'notebook/mediocre/selection/text/SelectionReader';
import InsertSymbolModalClass from 'notebook/mediocre/symbols/InsertSymbolModal';
import StaticFormatToolbarClass from 'notebook/mediocre/toolbars/StaticFormatToolbar';
import IntroEditorClass from 'notebook/protocols/editor/IntroEditor';
import MaterialsEditorClass from 'notebook/protocols/editor/MaterialsEditor';
import StepsEditorContainer from 'notebook/protocols/editor/StepsEditorContainer';
import TitleEditorClass from 'notebook/protocols/editor/TitleEditor';
import notifications from 'notifications';
import IntermediateBinder from 'ui-library/IntermediateBinder';
import ModalAnchor from 'ui-library/ModalAnchor';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

import {isHeadlessChrome, maybeUpdatePrintWarningForContentWidth} from 'notebook/mediocre/print/PrintUtil';
import * as selutil from 'notebook/mediocre/selection/text/SelUtil';
import ProtocolStoreTransforms from 'notebook/protocols/ProtocolStoreTransforms';
import ProtocolToolbar from 'notebook/protocols/editor/ProtocolToolbar';

const {AGGREGATE_TIME, StepLevel, TYPE_CRITICAL, TYPE_PAUSE, INSERT_SYMBOL, INSERT_WELL_PLATE, EditorKey} =
  StepConstants;
const STEP_FORMATS = [
  StepLevel.HEADER,
  StepLevel.STEP,
  StepLevel.DESC,
  AGGREGATE_TIME,
  TYPE_CRITICAL,
  TYPE_PAUSE,
];

class ProtocolEditor extends React.Component {
  static propTypes = {
    fileId: PropTypes.string.isRequired,
    protocol: PropTypes.shape({
      inEntry: PropTypes.bool,
      // permissions is not specified if inEntry
      permissions: PropTypes.shape({readable: PropTypes.bool.isRequired}),
    }).isRequired,
    optionsChildren: PropTypes.node,
    storeState: PropTypes.func.isRequired,
    restoreState: PropTypes.func.isRequired,
    requestSelection: PropTypes.func.isRequired,
    moreFormats: PropTypes.arrayOf(
      PropTypes.shape({
        format: PropTypes.string.isRequired,
        onClick: PropTypes.func.isRequired,
        tooltip: PropTypes.arrayOf(PropTypes.string),
        moreKey: PropTypes.string,
      })
    ).isRequired,
    displayOptions: PropTypes.object,
    banner: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    spellCheck: PropTypes.bool.isRequired,
    showPrintMargins: PropTypes.bool.isRequired,
    printLayout: PropTypes.bool.isRequired,
    viewer: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    moreFormats: [],
    spellCheck: false,
    printLayout: false,
    viewer: false,
  };

  state = {
    selected: {},
    atSignState: null,
    hyperlinkState: null,
    formatState: FormatState.readFormats(),
    editorMargin: 0,
    editorWidth: 700,
    showInsertLinkModal: false,
    insertingSymbolState: null,
  };

  componentDidMount() {
    this._isMounted = true;
    window.addEventListener('resize', this._editorMarginThrottledResizeHandler);
    // When a buffer-tab is first rendered, it is not yet attached to the DOM, so we defer.
    _.defer(() => {
      this._editorMarginResizeHandler();
    });
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this._editorMarginThrottledResizeHandler);
    window.removeEventListener('resize', this._editorSizerThrottledHandleResize);
    this._isMounted = false;
  }

  componentDidUpdate(prevProps, prevState) {
    this._editorMarginResizeHandler();
    this._editorSizerHandleResize();

    maybeUpdatePrintWarningForContentWidth(this.state.containerWidth, this.props.displayOptions);
  }

  _editorMarginThrottledResizeHandler = throttle(() => this._editorMarginResizeHandler(), 250);

  _editorMarginResizeHandler = () => {
    let editorMargin;
    if (!this._isMounted) {
      return;
    }

    editorMargin = getEditorMargin(ReactDOM.findDOMNode(this.refs.editor));

    // Negative margins do not need to be offset (e.g. in QuickEditModal)
    if (editorMargin < 0) {
      editorMargin = 0;
    }

    if (editorMargin !== this.state.editorMargin) {
      this.setState({editorMargin});
    }
    window.addEventListener('resize', this._editorSizerThrottledHandleResize);
  };

  _editorSizerThrottledHandleResize = throttle(() => this._editorSizerHandleResize(), 250);

  _editorSizerHandleResize = () => {
    if (this._isMounted && isBrowser && !isHeadlessChrome()) {
      // In we did not guard against the non-browser environment, we'd set editorWidth to 0,
      // which results in undesired behavior when performing exports.

      const $container = $(ReactDOM.findDOMNode(this.refs.container));
      const containerWidth = $container.width();
      const containerHeight = $container.height();
      const editorWidth = $(ReactDOM.findDOMNode(this.refs.editor)).width();

      if (
        editorWidth !== this.state.editorWidth ||
        containerWidth !== this.state.containerWidth ||
        containerHeight !== this.state.containerHeight
      ) {
        this.setState({editorWidth, containerWidth, containerHeight});
      }
    }
  };

  openInsertLinkModal = (formats, partition, editingFormatIndex) => {
    this.setState({
      showInsertLinkModal: true,
      // Everything we need once the user clicks save on the edit link modal.
      editingLinkState: getEditingLinkState(formats, partition, editingFormatIndex),
    });
  };

  closeInsertLinkModal = () => {
    this.setState({editingLinkState: null, showInsertLinkModal: false});
  };

  openInsertSymbolModal = (index, partition, formats) => {
    this.setState({insertingSymbolState: {index, partition, formats}});
  };

  _closeSymbolModal = () => {
    this.setState({insertingSymbolState: null});
  };

  _insertSymbol = (symbol) => {
    const {formats, partition, index} = this.state.insertingSymbolState;
    const {formats: newFormats, text, end} = formatters.replaceText(formats, partition, symbol);
    // After insert, place cursor at end of range.
    this.updateFormattedText({text, start: end, end, formats: newFormats}, index);
    analytics.track('editor', 'inserted_symbol', {symbol});
  };

  renderInsertSymbolModal = () => (
    <ModalAnchor open={this.state.insertingSymbolState != null}>
      <InsertSymbolModalClass onRequestClose={this._closeSymbolModal} onRequestSubmit={this._insertSymbol} />
    </ModalAnchor>
  );

  nestedStoreState = (key, data) => {
    this.props.storeState(DocumentManagerComponentClass.keyData(key, data));
  };

  nestedRestoreState = (key, e, data) =>
    this.props.restoreState(e, DocumentManagerComponentClass.keyData(key, data));

  nestedRequestSelection = (key, data) => {
    this.props.requestSelection(DocumentManagerComponentClass.keyData(key, data));
  };

  isLockedWithEditWarn = () => {
    if (this.props.locked) {
      notifications.warn(this.props.banner != null ? this.props.banner : 'Editing is disabled.', {
        id: 'ProtocolEditor.isLockedWithEditWarn',
      });
    }
    return this.props.locked;
  };

  renderEditor = (key, ref, component, extraProps) => {
    if (extraProps == null) {
      extraProps = {};
    }
    return (
      <IntermediateBinder
        ref={ref}
        boundArg={key}
        storeState={this.nestedStoreState}
        restoreState={this.nestedRestoreState}
        requestSelection={this.nestedRequestSelection}
        formatHandler={this._formatHandler}
      >
        {(boundProps) =>
          React.createElement(component, {
            highlightIndex: key === this.state.highlightEditorKey ? this.state.highlightIndex : undefined,
            insertIndex: key === this.state.insertEditorKey ? this.state.insertIndex : undefined,
            protocol: this.props.protocol,
            locked: this.props.locked,
            spellCheck: this.props.spellCheck,
            updateProtocol: this.props.updateProtocol,
            metadataForRestore: DocumentManagerComponentClass.unkeyData(key, this.props.metadataForRestore),
            jumpTo: this.jumpTo,
            editorKey: key,
            isLockedWithEditWarn: this.isLockedWithEditWarn,
            viewer: this.props.viewer,
            ...boundProps,
            ...extraProps,
          })
        }
      </IntermediateBinder>
    );
  };

  setStepsEditorRef = (element) => {
    this.stepsEditorRef = element;
  };

  getStepsEditor = () => this.stepsEditorRef;

  jumpTo = ({section, row, location}) => {
    function selectionFor(cid, text) {
      const pos = location === 'start' ? 0 : text.length;
      return {selection: {cid, start: pos, end: pos}};
    }

    let selection;
    let item;
    let text;

    switch (section) {
      case EditorKey.TITLE:
        selection = selectionFor(this.getTitleCid(), this.props.protocol.name);
        break;
      case EditorKey.INTRO:
        selection = selectionFor(this.getIntroCid(), this.props.protocol.description);
        break;
      case EditorKey.STEPS: {
        const firstStep = this.props.protocol.steps[0];
        const lastStep = this.props.protocol.steps[this.props.protocol.steps.length - 1];
        const step = row === 'first' ? firstStep : lastStep;
        selection =
          location === 'start'
            ? this.getStepsEditor().selectionAtStart(step)
            : this.getStepsEditor().selectionAtEnd(step);
        break;
      }
      case EditorKey.MATERIALS:
        if (row === 'first') {
          [item] = Array.from(this.props.protocol.materials);
          text = item.name;
        } else {
          item = this.props.protocol.materials[this.props.protocol.materials.length - 1];
          text = item.name;
          if (item.components.length) {
            item = item.components[item.components.length - 1];
            text = item.raw_text;
          }
        }
        selection = selectionFor(item.cid, text);
        break;
      default:
        // eslint-disable-next-line no-console
        console.warn('Invalid section for ProtocolEditor.jumpTo:', section);
        return;
    }
    this.nestedRequestSelection(section, selection);
  };

  _handleOpenInsertSymbolModalForProtocolSection = (editorKey, index) => {
    const formats = (() => {
      switch (editorKey) {
        case EditorKey.STEPS:
          return this.atIndex(editorKey, index).formats;
        case EditorKey.MATERIALS: {
          const item = this.atIndex(editorKey, index);
          if (item.level === LEVEL_MATERIAL) {
            return item.material.formats;
          } else {
            return item.component.formats;
          }
        }
        case EditorKey.INTRO:
          return this.props.protocol.descriptionFormats;
        default:
          throw new Error(`Unexpected editor key: ${editorKey}`);
      }
    })();
    const partition = StaticFormatToolbarClass.getPartition(this.getEditor(), this.state.selected);
    this.openInsertSymbolModal({editorKey, index}, partition, formats);
  };

  _formatHandler = (editorKey, index, e) => {
    if (e.format === FormattersConstants.SYMBOL) {
      this._handleOpenInsertSymbolModalForProtocolSection(editorKey, index);
      return;
    }

    const parentFormat = _.findWhere(this.props.moreFormats, {format: e.format});
    if (parentFormat != null) {
      parentFormat.onClick();
      return;
    }
    this.nestedStoreState(editorKey, {selection: selutil.getSelectionIndices()});
    switch (editorKey) {
      case EditorKey.MATERIALS:
        this._formatHandlerMaterials(index, e);
        return;
      case EditorKey.INTRO:
        this._formatHandlerIntro(index, e);
        return;
      case EditorKey.STEPS:
        this._formatHandlerSteps(index, e);
        return;
      default:
        throw new Error(`Unexpected editor key: ${editorKey}`);
    }
  };

  _toolbarFormatHandler = (format, data) => {
    const {editorKey, index} = this.state.selected;
    const partition = StaticFormatToolbarClass.getPartition(this.getEditor(), this.state.selected);
    this._formatHandler(editorKey, index, {format, data, partition});
  };

  processIndexStr = (editorKey, index) => {
    if (editorKey === EditorKey.MATERIALS) {
      return index.split(',').map((part) => parseInt(part, 10));
    }
    return parseInt(index, 10);
  };

  getIntroCid = () => `${this.props.protocol.cid}-intro`;

  getTitleCid = () => `${this.props.protocol.cid}-title`;

  atIndex = (editorKey, index) => {
    switch (editorKey) {
      case EditorKey.STEPS:
        return this.props.protocol.steps[index];
      case EditorKey.MATERIALS:
        return ProtocolStoreTransforms.getMaterialByIndex(this.props.protocol, index);
      // We don't (currently) expect to get EditorKey.INTRO
      default:
        throw new Error(`Unexpected editor key: ${editorKey}`);
    }
  };

  _toolbarInsertItemHandler = (type) => {
    const {editorKey, index} = this.state.selected;
    if (type === INSERT_SYMBOL) {
      this._handleOpenInsertSymbolModalForProtocolSection(editorKey, index);
      return;
    }

    if (editorKey === EditorKey.STEPS) {
      let item = null;
      switch (type) {
        case StepLevel.HEADER:
        case StepLevel.STEP:
        case StepLevel.DESC:
          item = ProtocolStoreTransforms.makeStep('', formatters.defaultFormats(), type);
          break;
        case StepLevel.IMAGE:
          item = ProtocolStoreTransforms.makeImage();
          break;
        case StepLevel.TIMER:
          item = ProtocolStoreTransforms.makeTimer();
          break;
        case StepLevel.TABLE:
          item = this._makeTableItem(DEFAULT_TABLE_SIZE[0], DEFAULT_TABLE_SIZE[1]);
          break;
        case INSERT_WELL_PLATE:
          item = this._makeTableItem(DEFAULT_PLATE_SIZE[0], DEFAULT_PLATE_SIZE[1], {isWellPlate: true});
          break;
        default:
          throw new Error(`Unexpected type ${type} for editor key ${editorKey}`);
      }
      const steps = reactUpdate(this.props.protocol.steps, {$splice: [[index + 1, 0, item]]});
      this.props.updateProtocol({steps});
    } else {
      throw new Error(`Unexpected type ${type} for editor key ${editorKey}`);
    }
  };

  _insertTableOrWellPlate = (rows, cols, isWellPlate) => {
    const tableItem = this._makeTableItem(rows, cols, {isWellPlate});
    const steps = reactUpdate(this.props.protocol.steps, {
      $splice: [[this.state.selected.index + 1, 0, tableItem]],
    });
    this.props.updateProtocol({steps});
  };

  insertTableWithDimensions = (rows, cols) => {
    this._insertTableOrWellPlate(rows, cols, false);
  };

  insertWellPlateWithDimensions = (rows, cols) => {
    this._insertTableOrWellPlate(rows, cols, true);
  };

  _makeTableItem = (rows, cols, param) => {
    if (param == null) {
      param = {};
    }
    const {isWellPlate} = param;
    const usedTableNames = Array.from(this.props.protocol.steps)
      .filter((s) => s.level === StepLevel.TABLE)
      .map((s) => s.table.name);
    const tableName = excessutil.uniqueTableName(
      usedTableNames,
      isWellPlate ? TABLE_NAME_WELL_PREFIX : undefined
    );
    return ProtocolStoreTransforms.makeTable(tableName, null, rows, cols, {isWellPlate});
  };

  updateFormattedText = ({formats, text, start, end}, {editorKey, index}) => {
    let newMaterial;
    switch (editorKey) {
      case EditorKey.INTRO:
        this.props.updateProtocol({descriptionFormats: formats, description: text});
        this.nestedRequestSelection(EditorKey.INTRO, {selection: {start, end, cid: this.getIntroCid()}});
        break;
      case EditorKey.MATERIALS: {
        const item = this.atIndex(editorKey, index);
        if (item.level === LEVEL_MATERIAL) {
          newMaterial = reactUpdate(item.material, {$merge: {formats, name: text}});
        } else {
          const newComponent = reactUpdate(item.component, {$merge: {formats, raw_text: text}});
          newMaterial = reactUpdate(item.material, {
            components: {$merge: _.object([[index[1], newComponent]])},
          });
        }
        const {materials} = this.props.protocol;
        const newMaterials = reactUpdate(materials, {$merge: _.object([[index[0], newMaterial]])});
        this.props.updateProtocol({materials: newMaterials});
        this.nestedRequestSelection(EditorKey.MATERIALS, {selection: {cid: item.model.cid, start, end}});
        return;
      }
      case EditorKey.STEPS: {
        const item = this.atIndex(editorKey, index);
        const selection = {start, end, cid: item.cid};
        const $merge = {formats, text};
        this.updateSteps(index, $merge, selection);
        break;
      }
      default:
        throw new Error(`Unexpected error key: ${editorKey}`);
    }
  };

  _formatHandlerMaterials = (index, e) => {
    const item = this.atIndex(EditorKey.MATERIALS, index);
    formatText(
      item.model.formats,
      e,
      {editorKey: EditorKey.MATERIALS, index},
      this.openInsertLinkModal,
      this.updateFormattedText
    );
  };

  _formatHandlerIntro = (index, e) => {
    formatText(
      this.props.protocol.descriptionFormats,
      e,
      {editorKey: EditorKey.INTRO, index},
      this.openInsertLinkModal,
      this.updateFormattedText
    );
  };

  updateSteps = (index, $merge, selection) => {
    const steps = reactUpdate(this.props.protocol.steps, _.object([[index, {$merge}]]));
    this.props.updateProtocol({steps});
    this.nestedRequestSelection(EditorKey.STEPS, {selection});
  };

  _formatHandlerSteps = (index, e) => {
    const {format} = e;
    let item = this.atIndex(EditorKey.STEPS, index);
    if (format === 'delete') {
      this.nestedStoreState(EditorKey.STEPS, {selection: {cid: item.cid, start: 0, end: 0}});
      let selection = null;
      if (index > 0) {
        item = this.atIndex(EditorKey.STEPS, index - 1);
        if (item.text != null) {
          // TODO(eln): Make StepEditor.getPluginByItem work to generalize
          selection = {cid: item.cid, start: item.text.length, end: item.text.length};
        }
      } else if (this.props.protocol.steps.length > 1) {
        item = this.atIndex(EditorKey.STEPS, 1);
        if (item.text != null) {
          selection = {cid: item.cid, start: 0, end: 0};
        }
      }

      const steps = reactUpdate(this.props.protocol.steps, {$splice: [[index, 1]]});
      this.props.updateProtocol({steps});
      if (selection != null) {
        this.nestedRequestSelection(EditorKey.STEPS, {selection});
      }
      return;
    }

    switch (format) {
      case AGGREGATE_TIME: {
        const $merge = {time_seconds: item.time_seconds ? null : 10 * 60};
        this.updateSteps(index, $merge, selutil.getSelectionIndices());
        break;
      }
      case TYPE_CRITICAL:
      case TYPE_PAUSE: {
        const type = item.type === format ? null : format;
        this.updateSteps(index, {type}, selutil.getSelectionIndices());
        break;
      }
      case StepLevel.HEADER:
      case StepLevel.STEP:
      case StepLevel.DESC:
        this.updateSteps(index, {level: format}, selutil.getSelectionIndices());
        break;
      default:
        formatText(
          item.formats,
          e,
          {editorKey: EditorKey.STEPS, index},
          this.openInsertLinkModal,
          this.updateFormattedText
        );
    }
  };

  _toolbarMouseOverHandler = (fmt) => {
    const {editorKey, index} = this.state.selected;
    if ((editorKey === EditorKey.STEPS && STEP_FORMATS.includes(fmt)) || fmt === 'delete') {
      this.setState({highlightEditorKey: editorKey, highlightIndex: index});
    }
  };

  _toolbarInsertMouseOverHandler = () => {
    const {editorKey, index} = this.state.selected;
    this.setState({insertIndex: index, insertEditorKey: editorKey});
  };

  _toolbarInsertMouseOutHandler = () => {
    this.setState({insertIndex: null, insertEditorKey: null});
  };

  _toolbarMouseOutHandler = () => {
    this.setState({highlightIndex: null, highlightEditorKey: null});
  };

  getEditor = () => ReactDOM.findDOMNode(this.refs.editor);

  onMouseDownCatcher = (e) => {
    if (this.props.locked) {
      return;
    }
    if (
      ![ReactDOM.findDOMNode(this.refs.editor), ReactDOM.findDOMNode(this.getStepsEditor())].includes(
        e.target
      )
    ) {
      return;
    }

    e.preventDefault();
    const $steps = $(ReactDOM.findDOMNode(this.getStepsEditor())).find('.mediocre-item');
    const maxStepY = _.max(
      $steps.map(function () {
        return $(this).offset().top + $(this).height();
      })
    );
    if (e.pageY <= maxStepY) {
      return;
    }

    const lastStep = this.props.protocol.steps[this.props.protocol.steps.length - 1];

    if (lastStep != null && this.getStepsEditor().isItemTextual(lastStep)) {
      this.nestedRequestSelection(EditorKey.STEPS, this.getStepsEditor().selectionAtEnd(lastStep));
      return;
    }

    const item = ProtocolStoreTransforms.makeStep('', formatters.defaultFormats(), StepLevel.STEP);
    const steps = reactUpdate(this.props.protocol.steps, {$push: [item]});
    this.props.updateProtocol({steps});
    this.nestedRequestSelection(EditorKey.STEPS, this.getStepsEditor().selectionInit(item));
  };

  handleChangeSelected = (value) => {
    this.setState({selected: value});
  };

  handleChangeFormatState = (value) => {
    this.setState({formatState: value});
  };

  handleChangeAtSignState = (value) => {
    this.setState({atSignState: value});
  };

  handleChangeSlashSignState = (value) => {
    this.setState({slashSignState: value});
  };

  handleChangeHyperlinkState = (value) => {
    this.setState({hyperlinkState: value});
  };

  handleChangeNonEmptySelectionState = (value) => {
    this.setState({nonEmptySelectionState: value});
  };

  render() {
    const {editorKey, index, hasNonEmptyTextSelection} = this.state.selected;
    const stepItem = editorKey === EditorKey.STEPS ? this.atIndex(editorKey, index) : undefined;
    return (
      <div className="protocolEditor">
        {
          // Use a DIV container to prevent modals's <noscript> from causing a large reflow
          <div>
            <EditLinkModal
              fileId={this.props.fileId}
              showInsertLinkModal={this.state.showInsertLinkModal}
              editingLinkState={this.state.editingLinkState}
              closeInsertLinkModal={this.closeInsertLinkModal}
              updateFormattedText={this.updateFormattedText}
            />
            {this.renderInsertSymbolModal()}
          </div>
        }
        {this.props.showToolbar ? (
          <BufferOptions
            leftChildren={React.createElement(
              BufferOptionsItem,
              {key: 'toolbar'},
              <ProtocolToolbar
                formatState={this.state.formatState}
                mouseOverHandler={this._toolbarMouseOverHandler}
                mouseOutHandler={this._toolbarMouseOutHandler}
                insertMouseOverHandler={this._toolbarInsertMouseOverHandler}
                insertMouseOutHandler={this._toolbarInsertMouseOutHandler}
                insertHandler={this._toolbarInsertItemHandler}
                insertTableWithDimensions={this.insertTableWithDimensions}
                insertWellPlateWithDimensions={this.insertWellPlateWithDimensions}
                formatHandler={this._toolbarFormatHandler}
                locked={this.props.locked}
                stepLevel={stepItem != null ? stepItem.level : undefined}
                stepType={stepItem != null ? stepItem.type : undefined}
                stepHasTime={stepItem != null && stepItem.time_seconds > 0}
                editorKey={editorKey}
                printOptions={this.props.printOptions}
                printHandler={this.props.printHandler}
                moreFormats={this.props.moreFormats}
                hasNonEmptyTextSelection={hasNonEmptyTextSelection || false}
              />
            )}
            banner={this.props.banner}
            rightChildren={[
              !this.props.protocol.inEntry &&
              (this.props.protocol.permissions != null
                ? this.props.protocol.permissions.readable
                : undefined) ? (
                <BufferOptionsItem key="protocol-link">
                  <a
                    className="u-no-text-decoration u-bold-font-weight"
                    href={this.props.protocol.url}
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    {'Discuss '}
                    <BenchlingIcon icon="arrow-up-right-from-square" />
                  </a>
                </BufferOptionsItem>
              ) : undefined,
              this.props.displayOptions != null ? (
                <BufferOptionsItem className="u-vertical-center-items" key="display-options">
                  <DisplayOptions dropLeft={true} options={this.props.displayOptions} />
                </BufferOptionsItem>
              ) : undefined,
            ]}
          />
        ) : undefined}
        <div
          ref="container"
          className={classNames('protocolEditor-pageContainer', {'is-printLayout': this.props.printLayout})}
        >
          {this.state.hyperlinkState != null ? (
            <PositionedLinkPopover
              hyperlinkState={this.state.hyperlinkState}
              onChange={() => {
                this._toolbarFormatHandler(FormattersConstants.LINK);
              }}
              onRemove={(e) => {
                this._toolbarFormatHandler(FormattersConstants.SET_LINK, {url: null});
              }}
              containerWidth={this.state.containerWidth}
            />
          ) : undefined}

          <div className="protocolEditor-page">
            <div ref="editor" className="protocolEditor-contentWrapper" onMouseDown={this.onMouseDownCatcher}>
              {this.renderEditor(EditorKey.TITLE, null, TitleEditorClass, {
                cid: this.getTitleCid(),
              })}
              <SelectionReader
                selected={this.state.selected}
                onChangeSelected={this.handleChangeSelected}
                formatState={this.state.formatState}
                onChangeFormatState={this.handleChangeFormatState}
                atSignState={this.state.atSignState}
                onChangeAtSignState={this.handleChangeAtSignState}
                hyperlinkState={this.state.hyperlinkState}
                onChangeHyperlinkState={this.handleChangeHyperlinkState}
                processIndex={this.processIndexStr}
                scrollableParentSelector=".protocolEditor-pageContainer"
                slashSignState={this.state.slashSignState}
                onChangeSlashSignState={this.handleChangeSlashSignState}
                nonEmptySelectionState={this.state.nonEmptySelectionState}
                onChangeNonEmptySelectionState={this.handleChangeNonEmptySelectionState}
              >
                <div>
                  <h2>Introduction</h2>
                  {this.renderEditor(EditorKey.INTRO, null, IntroEditorClass, {
                    cid: this.getIntroCid(),
                  })}
                  <h2>Materials</h2>
                  {this.renderEditor(EditorKey.MATERIALS, null, MaterialsEditorClass)}
                  <h2>Procedure</h2>
                  {this.renderEditor(EditorKey.STEPS, 'stepsEditorBinder', StepsEditorContainer, {
                    setRef: this.setStepsEditorRef,
                    fileId: this.props.fileId,
                    openManageSelectorsModal: this.props.openManageSelectorsModal,
                    printLayout: this.props.printLayout,
                    editorMargin: this.state.editorMargin,
                  })}
                </div>
              </SelectionReader>
              {this.props.showPrintMargins ? (
                <div>
                  <div className="mediocre-pageMargin mediocre-pageMargin--left" />
                  <div className="mediocre-pageMargin mediocre-pageMargin--right" />
                </div>
              ) : undefined}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ProtocolEditor;
